import { Box, Typography } from "@mui/material";
import TransactionsTable from "./table";

const TicketsValidationPage = () => {
  return (
    <Box p={"30px"}>
      <Typography mb={{xs: 2, md :4}} fontSize={"22px"} fontWeight={600}>
        Tickets Validation
      </Typography>
      <TransactionsTable />
    </Box>
  );
};

export default TicketsValidationPage;
